<button
  on:click="{click}"
  data-heap-cancel-message-picker
  class="ne-close">
  <div class="ne-close-text">Close</div>
  <div class="ne-close-icon"></div>
</button>

<script>
  export let click;
</script>
